import { gql } from '@apollo/client'

export const MUTATION_PURCHASE_DEVICE = gql`
  mutation mutationPurchaseDevice($input: PurchaseDeviceCaseItemInput) {
    createPurchaseDeviceCaseItem(input: $input) {
      id
    }
  }
`
